import { getFeature } from 'Cloud/Application/FeaturesEs6';

/**
 *  @see https://jira.vk.team/browse/CLOUDWEB-20260
 */
export const GET_CHOSEN_EDITOR_FROM_LIST = getFeature('get-chosen-editor-from-list') || false;
